export enum ContractingEntity {
  aus = 'AU',
  fwt = 'ZA',
  unknown = 'Unknown'
}
